// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3D9yC","inputWrap":"Table_inputWrap__28ray","col":"Table_col__2Qe5H","bmiTooltip":"Table_bmiTooltip__2p5pp"};